/* Landing relojteens — JS extraido de Reloj Teens - Kit Dama/index.html.
   Cargado por layout/landing.liquid (case 'relojteens'). */

// Galería: thumbs → main
document.querySelectorAll('#thumbs .xs-thumb').forEach(t=>{
  t.addEventListener('click',()=>{
    document.querySelectorAll('#thumbs .xs-thumb').forEach(x=>x.classList.remove('activo'));
    t.classList.add('activo');
    const main=document.getElementById('galeriaImg');
    main.style.display='';
    main.src=t.dataset.src;
  });
});

// Selector de variante → nombre + imagen principal + aviso de stock
const stock=document.querySelector('.xs-stock');
document.querySelectorAll('#vars .xs-var').forEach(v=>{
  v.addEventListener('click',()=>{
    document.querySelectorAll('#vars .xs-var').forEach(x=>x.classList.remove('activo'));
    v.classList.add('activo');
    document.querySelectorAll('#thumbs .xs-thumb').forEach(x=>x.classList.remove('activo'));
    document.getElementById('varNombre').textContent=v.dataset.nombre;
    const main=document.getElementById('galeriaImg');
    main.style.display='';
    main.src=v.dataset.hero;
    stock.innerHTML='🔥 Quedan pocas unidades del estilo '+v.dataset.nombre.replace(' · ',' · ');
  });
});

// Bundles: selección + precio del sticky
document.querySelectorAll('#bundles .xs-bundle').forEach(b=>{
  b.addEventListener('click',()=>{
    document.querySelectorAll('#bundles .xs-bundle').forEach(x=>x.classList.remove('activo'));
    b.classList.add('activo');
    document.getElementById('stickyPrecio').innerHTML=b.dataset.precio+' <s>'+b.dataset.antes+'</s>';
  });
});

// Countdown 6h con persistencia por sesión
(function(){
  const KEY='relojFin';
  let fin=sessionStorage.getItem(KEY);
  if(!fin){fin=Date.now()+6*3600*1000;sessionStorage.setItem(KEY,fin);}
  fin=parseInt(fin,10);
  const p=n=>String(n).padStart(2,'0');
  function tick(){
    let d=Math.max(0,fin-Date.now());
    const s=Math.floor(d/1000);
    document.getElementById('cH').textContent=p(Math.floor(s/3600));
    document.getElementById('cM').textContent=p(Math.floor(s%3600/60));
    document.getElementById('cS').textContent=p(s%60);
  }
  tick();setInterval(tick,1000);
})();

// Sticky: aparece al pasar el hero
const hero=document.getElementById('comprar');
const bar=document.getElementById('stickyBar');
function chequearSticky(){
  const pasado=hero.getBoundingClientRect().bottom<0;
  bar.style.transform=pasado?'translateY(0)':'translateY(110%)';
}
bar.style.transition='transform .28s ease';
chequearSticky();
window.addEventListener('scroll',chequearSticky,{passive:true});

/* ============================================================
   Variante por (pulso, fondo) + cantidad del combo + trigger Releasit COD
   El producto tiene 4 variantes REALES mapeadas 1:1 con Dropi, asi que los
   combos NO son variantes: son la misma variante con quantity N + descuentos
   automaticos de Shopify. Ver memory/project_northpower_landing.
   El match es por ATRIBUTO, nunca por SKU (Dropi los re-escribe al re-importar
   — ver memory/feedback_dropi_resku_variant_match).
   NO usar _rsiV2.setState como primer path: solo el click nativo del boton
   Releasit re-lee window.productData tras cambiar la variante.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function findVariant(pulso, fondo) {
    var vs = window.RT_VARIANTS || [];
    for (var i = 0; i < vs.length; i++) {
      if (norm(vs[i].pulso) === norm(pulso) && norm(vs[i].fondo) === norm(fondo)) return vs[i];
    }
    return null;
  }

  var selectedVariantId = null;
  var selectedQty = 1;

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  var stockEl = document.querySelector('.relojteens-landing .xs-stock');

  function syncFromDom() {
    var sw = document.querySelector('.relojteens-landing #vars .xs-var.activo')
          || document.querySelector('.relojteens-landing #vars .xs-var');
    var bd = document.querySelector('.relojteens-landing #bundles .xs-bundle.activo')
          || document.querySelector('.relojteens-landing #bundles .xs-bundle');
    if (!sw) return;
    var v = findVariant(sw.getAttribute('data-pulso'), sw.getAttribute('data-fondo'));
    selectedQty = bd ? (parseInt(bd.getAttribute('data-bundle-qty'), 10) || 1) : 1;
    if (v) {
      selectedVariantId = v.id;
      setVariantOnAllForms(v.id, selectedQty);
      if (stockEl && v.available === false) {
        stockEl.innerHTML = 'Ese estilo esta agotado por ahora — elige otro.';
      }
    }
  }

  // el JS de arriba ya mueve la clase .activo; solo re-leemos el DOM despues
  document.querySelectorAll('.relojteens-landing #vars .xs-var, .relojteens-landing #bundles .xs-bundle')
    .forEach(function (el) { el.addEventListener('click', function () { setTimeout(syncFromDom, 0); }); });

  syncFromDom();

  window.relojteensTriggerCOD = function () {
    syncFromDom();
    if (selectedVariantId) setVariantOnAllForms(selectedVariantId, selectedQty);
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
